import React, { useState } from 'react';
import { LogOut, Search, Shield } from 'lucide-react';
import Tip from '../../components/common/Tip';

interface ApplicationHeader7Props {
  loginId?: string;
  name?: string;
  onLogoClick?: () => void;
  onLogout: () => void;
}

const ApplicationHeader7: React.FC<ApplicationHeader7Props> = ({
  loginId,
  name,
  onLogoClick,
  onLogout,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);

  const displayName = name || loginId || 'Super Admin';
  const initials = displayName.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();

  return (
    <header className="app-header sa-header">
      <div className="app-header-start">
        <button
          className="app-header-brand"
          onClick={onLogoClick}
          aria-label="Super Admin Home"
          data-testid="BTN_sa_header_brand"
        >
          <div className="app-header-logo-wrap">
            <img src={process.env.PUBLIC_URL + '/anygrc-logo-light.png'} alt="AnyGRC" className="app-header-logo-img" />
          </div>
        </button>
        <span className="app-header-pipe" />
        <div className="app-header-title-block">
          <span className="app-header-title-icon"><Shield size={22} /></span>
          <span className="app-header-title-text">SUPER ADMIN PORTAL</span>
          <span className="app-header-title-divider">|</span>
          <span className="app-header-entity-name">AnyGRC</span>
        </div>
      </div>

      <div className="app-header-center" />

      <div className="app-header-end">
        {searchOpen ? (
          <div className="app-header-search-expanded">
            <Search size={14} />
            <input
              autoFocus
              type="text"
              placeholder="Search entities, admins, users..."
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              onBlur={() => setSearchOpen(false)}
              onKeyDown={e => e.key === 'Escape' && setSearchOpen(false)}
              data-testid="INP_sa_header_search"
            />
          </div>
        ) : (
          <button
            className="app-header-search-icon-btn"
            onClick={() => setSearchOpen(true)}
            aria-label="Search"
            data-testid="BTN_sa_header_search_open"
          >
            <Search size={20} />
          </button>
        )}

        {/* Notification icon hidden
        <button className="app-header-notif" aria-label="Notifications" data-testid="BTN_sa_header_notifications">
          <Bell size={20} />
          <span className="app-header-notif-dot" />
        </button>
        */}

        <div className="app-header-user">
          <div className="app-header-user-info">
            <span className="app-header-user-name">{displayName}</span>
          </div>
          <div className="app-header-avatar sa-header-avatar">{initials}</div>
          <Tip text="Sign Out">
            <button className="app-header-signout" onClick={onLogout} data-testid="BTN_sa_header_signout">
              <LogOut size={16} />
            </button>
          </Tip>
        </div>
      </div>
    </header>
  );
};

export default ApplicationHeader7;
